import React, { useEffect, useRef } from "react";
import "../../../../assets/style/featuresStyle/menuConfig.scss";
import { IconDelete, IconEdit } from "../../../../assets/icon";
import { setOpenPUDelete } from "../../../../services/slice/PopUpSlice";
import { useDispatch } from "react-redux";
import { setOpenModalEditTabMenu } from "../../../../services/slice/ConfigMenuSlice";

const ModalRightClickToMenu = ({ value, top, right, setOpen }) => {
  const puRef = useRef();
  const dispatch = useDispatch();
  function useOutsideAlerter(ref) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setOpen(false);
        }
      }

      // Bind the event listener
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }
  useOutsideAlerter(puRef);
  const handleEdit = () => {
    dispatch(setOpenModalEditTabMenu({ data: value, isOpen: true }));
    setOpen(false);
  };
  const handleDelete = () => {
    dispatch(
      setOpenPUDelete({ stateOpen: true, content: value.nameVn, id: "" })
    );
    setOpen(false);
  };
  return (
    <>
      <ul
        ref={puRef}
        style={{ position: "absolute", top: top - 80, left: right }}
        className="wrapprModalRigthClick"
      >
        <li className="item" onClick={handleEdit}>
          <IconEdit />
          <span> Chỉnh sửa</span>
        </li>
        <li className="item" onClick={handleDelete}>
          <IconDelete /> <span>Xóa</span>
        </li>
      </ul>
    </>
  );
};

export default ModalRightClickToMenu;
